import { useEffect, useState } from "react";
import { Address } from "ton";
import { CopyOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useTonAddress } from "@tonconnect/ui-react";
import { Button, Table, Flex } from "antd";
import type { TableProps } from "antd";
import { ROUTES } from "consts";
import copyHandler, { SliceAddress, client } from "../../config";
import { ManagementHeading, ManagementPage, ManagementTable } from "./styled";

interface ConfigType {
  tokenAddr: string;
  name: string;
  symbol: string;
  decimals: number;
  balance: string;
  image: string;
}

export function Management() {
  const walletAddress = useTonAddress();

  const [config, setConfig] = useState<ConfigType[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    getJettons();
  }, []);

  const getJettons = async () => {
    try {
      const jettons = await client.accounts.getAccountJettonsBalances(walletAddress);
      console.log(jettons, "jettons");
      const tokenArr: ConfigType[] = [];
      jettons.balances.forEach((item) => {
        const _obj = {
          tokenAddr: item.jetton.address,
          name: item.jetton.name,
          symbol: item.jetton.symbol,
          decimals: item.jetton.decimals,
          balance: (Number(item.balance) / 10 ** item.jetton.decimals).toString(),
          image: item.jetton.image,
        };
        tokenArr.push(_obj);
      });
      setConfig(tokenArr);
    } catch (error) {
      console.log(error);
    }
  };

  const getTokenAddre = (_token: string) => {
    const _id = Address.parse(_token!).toFriendly();
    return _id;
  };

  const columns: TableProps<ConfigType>["columns"] = [
    {
      title: "代币地址",
      key: "image",
      dataIndex: "image",
      render: (text) => (
        <Flex>
          <img src={text} width={30} alt="logo" />
        </Flex>
      ),
    },
    {
      title: "代币地址",
      key: "tokenAddr",
      dataIndex: "tokenAddr",
      render: (text) => (
        <Flex>
          <div>{SliceAddress(getTokenAddre(text))}</div>
          <CopyOutlined className="copy" onClick={() => copyHandler(getTokenAddre(text))} />
        </Flex>
      ),
    },
    {
      title: "全称",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "简称",
      dataIndex: "symbol",
      key: "symbol",
    },
    {
      title: "精度",
      dataIndex: "decimals",
      key: "decimals",
    },

    {
      title: "余额",
      key: "balance",
      dataIndex: "balance",
    },
    {
      title: "操作",
      key: "manage",
      dataIndex: "tokenAddr",
      render: (text) => (
        <Button type="primary" onClick={() => navigate(`${ROUTES.jetton}/${getTokenAddre(text)}`)}>
          进入控制台
        </Button>
      ),
    },
  ];

  return (
    <ManagementPage component="section">
      <ManagementHeading>管理代币</ManagementHeading>
      <ManagementTable>
        <Table columns={columns} dataSource={config} rowKey="tokenAddr" scroll={{ x: 760 }} />
      </ManagementTable>
    </ManagementPage>
  );
}
